import { Card, CardActionArea, Grid, Typography } from '@mui/material'
import "../Dashboard/../ProjectSupport/ProjectSupport.css";
import React, { useContext } from 'react'
import {FaChartLine, FaRegMoneyBillAlt } from "react-icons/fa";
import {  formatNumber } from 'utilities/utilities';
import { ProviderProjectDashboard } from './ProjectSupportDashboard';

const CardProjectSupport = ({ sMode }) => {

    const {
        nProjectTotal,
        nApproveBudgetTotal,
    } = useContext(ProviderProjectDashboard);

    return (
        <>
            {(sMode === "Total") ? (
                <Card
                    className="styled-card-Total"
                    variant="outlined"
                    sx={{
                        position: 'relative',
                        padding: '0px !important'
                    }}
                >
                    <CardActionArea
                        sx={{
                            padding: '12px !important'
                        }}
                    >
                        <Grid container spacing={1} justifyContent={"flex-start"} alignItems={"center"}>
                            <Grid item xs={12} >
                                <Grid container spacing={2} alignItems={"center"}>
                                    <Grid item xs={2} >
                                        <div className="circle-card1">
                                            <div className="div-card-Icon">
                                                <FaChartLine style={{ fontSize: '3.5em', color: 'white' }} />
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={10} >
                                        <Grid container justifyContent={"flex-end"}>
                                            <Grid item xs={12} container justifyContent="flex-end">
                                                <Typography className='card-Total-title'>จำนวนโครงการ</Typography>
                                            </Grid>
                                            <Grid item xs={12} container justifyContent="flex-end">
                                                <Typography className='card-Total-title'>{formatNumber(nProjectTotal, 0)}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardActionArea>
                </Card>
            ) :
                <Card
                    className="styled-card-Price"
                    variant="outlined"
                    sx={{
                        position: 'relative',
                        padding: '0px !important'
                    }}
                >
                    <CardActionArea
                        sx={{
                            padding: '12px !important'
                        }}
                    >
                        <Grid container spacing={1} alignItems={"center"}>
                            <Grid item xs={12} >
                                <Grid container spacing={3} alignItems={"center"}>
                                    <Grid item xs={2} >
                                        <div className="circle-card2">
                                            <div className="div-card-Icon">
                                                <FaRegMoneyBillAlt style={{ fontSize: '4em', color: 'white' }} />
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item xs={10} >
                                        <Grid container justifyContent={"flex-end"}>
                                            <Grid item xs={12} container justifyContent="flex-end">
                                                <Typography className='card-Price-title'>วงเงินที่ได้รับอนุมัติ</Typography>
                                            </Grid>
                                            <Grid item xs={12} container justifyContent="flex-end">
                                                <Typography className='card-Price-title'>  {formatNumber(nApproveBudgetTotal, 0)} บาท</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardActionArea>
                </Card>
            }
        </>
    )
}

export default CardProjectSupport
